import { motion } from "framer-motion";
import { Palette, Plug, ArrowUpRight } from "lucide-react";

const services = [
  {
    testid: "service-card-web",
    title: "Web Sitesi & SaaS",
    desc: "Kurumsal siteler, e-ticaret, yönetim panelleri ve tam kapsamlı web uygulamaları. Modern, hızlı, SEO uyumlu.",
    img: "https://images.unsplash.com/photo-1753998941540-081eed4f6397?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    testid: "service-card-mobile",
    title: "Mobil Uygulama",
    desc: "iOS ve Android için tek kod tabanıyla native performanslı uygulamalar. Fikirden mağaza yayınına kadar.",
    img: "https://images.unsplash.com/photo-1770734360042-676ef707d022?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

const Services = () => (
  <section id="hizmetler" className="px-6 lg:px-16 py-28 bg-[#0F0E17]">
    <div className="max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6"
      >
        <div>
          <span className="font-code text-xs text-[#10B981] tracking-[0.3em]">HİZMETLER</span>
          <h2 className="font-display font-bold text-4xl sm:text-5xl mt-4 tracking-tight">
            Ne inşa edebilirim<span className="text-[#10B981]">?</span>
          </h2>
        </div>
        <p className="text-[#9CA3AF] max-w-sm text-sm leading-relaxed">
          İşletmenin ihtiyacına göre şekillenen, uçtan uca dijital çözümler.
        </p>
      </motion.div>

      <div className="grid md:grid-cols-2 gap-6">
        {services.map((s, i) => (
          <motion.article
            key={s.testid}
            data-testid={s.testid}
            initial={{ opacity: 0, y: 48 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.12 }}
            className="glow-card group bg-[#151421] border border-white/[0.08] rounded-2xl overflow-hidden"
          >
            <div className="relative h-56 overflow-hidden">
              <img
                src={s.img}
                alt={s.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#151421] via-[#151421]/30 to-transparent" />
            </div>
            <div className="p-8">
              <h3 className="font-display font-bold text-2xl tracking-tight flex items-center justify-between">
                {s.title}
                <ArrowUpRight size={20} className="text-[#10B981] opacity-0 -translate-x-2 translate-y-2 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-all duration-500" />
              </h3>
              <p className="text-[#9CA3AF] text-sm leading-relaxed mt-3">{s.desc}</p>
            </div>
          </motion.article>
        ))}

        <motion.article
          data-testid="service-card-uiux"
          initial={{ opacity: 0, y: 48 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="glow-card bg-[#151421] border border-white/[0.08] rounded-2xl p-8"
        >
          <div className="w-12 h-12 rounded-xl bg-[#F59E0B]/10 border border-[#F59E0B]/20 flex items-center justify-center mb-6">
            <Palette size={22} className="text-[#F59E0B]" />
          </div>
          <h3 className="font-display font-bold text-2xl tracking-tight">UI/UX Tasarım</h3>
          <p className="text-[#9CA3AF] text-sm leading-relaxed mt-3">
            Kullanıcıların ilk bakışta anlayacağı arayüzler. Araştırma, wireframe, prototip ve final tasarım.
          </p>
        </motion.article>

        <motion.article
          data-testid="service-card-api"
          initial={{ opacity: 0, y: 48 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="glow-card bg-[#151421] border border-white/[0.08] rounded-2xl p-8"
        >
          <div className="w-12 h-12 rounded-xl bg-[#6366F1]/10 border border-[#6366F1]/20 flex items-center justify-center mb-6">
            <Plug size={22} className="text-[#6366F1]" />
          </div>
          <h3 className="font-display font-bold text-2xl tracking-tight">API & Ödeme Entegrasyonları</h3>
          <p className="text-[#9CA3AF] text-sm leading-relaxed mt-3">
            Ödeme sistemleri, kargo, SMS/e-posta servisleri ve üçüncü parti API'lerle sorunsuz entegrasyon.
          </p>
        </motion.article>
      </div>
    </div>
  </section>
);

export default Services;
